import Api from '../../../../services/Api';
import IPicture from './IPicture';

export default class StockPicture implements IPicture {
  constructor(private url: string, private mediaId: string) {}

  public getUrl(): string {
    return this.url;
  }

  public async getImageForPreview(): Promise<string> {
    const result = await Api.getStockImageForPreview(this.mediaId);

    return result.data.PresignedUrl;
  }
}
